<template>
    <div class="autocomplete">
        <div class="autocomplete__field">
            <input
                type="text"
                v-model="query"
                autocomplete="off"
                class="form-control autocomplete__input"
                :readonly="isSelected"
                v-bind="$attrs"
                @input="handleInputChanged"
                @focusout="handleFocusout"
                ref="input"
            >
            <template v-if="loading">
                <div class="autocomplete__spinner">
                    <div class="spinner-border spinner-border-sm"></div>
                </div>
            </template>
            <template v-else-if="isSelected">
                <button class="close autocomplete__clear p-2" type="button" @click.prevent="handleClearClicked">
                    <svg class="d-block" width="10" height="10">
                        <use xlink:href="#sprite-close"></use>
                    </svg>
                </button>
            </template>
        </div>

        <div class="dropdown-menu autocomplete__dropdown" :class="{ 'show':dropdownVisible }" @focusout="handleFocusout" ref="dropdown">
            <template v-if="results && results.length">
                <template v-for="venueRoom in results">
                    <a class="dropdown-item" href="#" @click.prevent="handleSelected(venueRoom)" :key="venueRoom.id">
                        <strong>{{ venueRoom.venue.title }}</strong> <span class="mx-1">–</span> {{ venueRoom.name }}
                        <div class="small text-muted mt-1">{{ venueRoom.city }}</div>
                    </a>
                </template>
            </template>
            <template v-else>
                <div class="dropdown-item disabled">
                    Aucun résultat
                </div>
            </template>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item text-primary" href="#" @click.prevent="handleCustomClicked">
                La salle est introuvable ? Cliquez ici pour l'ajouter.
            </a>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash/debounce';

export default {
        props: {
            value: Object,
        },
        data() {
            return {
                query: '',
                loading: false,
                results: null,
                dropdownVisible: false,
                customRoom: null,
            }
        },
        watch: {
            value: 'init',
        },
        computed: {
            isSelected() {
                return !!this.value;
            },
        },
        methods: {
            handleInputChanged(e) {
                this.query = e.target.value;
                if(this.query.length < 3) {
                    this.dropdownVisible = false;
                    return;
                }
                this.loading = true;
                axios.get('/autocomplete/venueRooms', {
                    params: {
                        q: this.query,
                    },
                })
                .then(response => {
                    this.dropdownVisible = true;
                    this.results = response.data.data;
                })
                .finally(() => {
                    this.loading = false;
                })
            },
            handleFocusout(e) {
                if(!e.relatedTarget || e.relatedTarget && this.$el.contains(e.relatedTarget)) {
                    return;
                }
                this.close();
            },
            handleSelected(venueRoom) {
                this.query = `${venueRoom.venue.title} - ${venueRoom.name}`;
                this.$emit('input', venueRoom);
                this.dropdownVisible = false;
            },
            handleCustomClicked() {
                this.$emit('custom-click');
            },
            handleClearClicked() {
                this.$emit('clear');
                this.$emit('input', null);
                this.query = '';
                this.$refs.input.removeAttribute('readonly');
                this.$refs.input.focus();
            },
            handleClickOutside(e) {
                console.log(e.target);
                if(!this.$el.contains(e.target)) {
                    this.close();
                }
            },
            close() {
                this.dropdownVisible = false;
                if(!this.isSelected) {
                    this.query = '';
                }
            },
            init() {
                if(this.value) {
                    this.query = `${this.value.venue.title} – ${this.value.name}`;
                }
            }
        },
        created() {
            this.handleInputChanged = debounce(this.handleInputChanged, 200);
            this.init();
        },
        mounted() {
            window.addEventListener('click', this.handleClickOutside);
        },
        destroyed() {
            window.removeEventListener('click', this.handleClickOutside);
        }
    }
</script>